export default "__VITE_ASSET__P03WsSt4__"